import { useState } from "react";

// interface TextProps {
//   text: string;
//   setText: any;
// }

const TextFieldDatasource = ({ text, setText }) => {
  return (
    <div className="">
      <textarea
        id="textArea"
        rows={10}
        value={text}
        onChange={(e) => setText(e.target.value)}
        className=" block w-full p-2.5 border border-gray-300 rounded-lg shadow-sm focus:ring-blue-500 focus:border-blue-500"
        placeholder="Enter training text to train your bot  - (eg: Important info on your company)"
      />
    </div>
  );
};

export default TextFieldDatasource;
